/** Service that emitted a telemetry metric */
export var TelemetryService;
(function (TelemetryService) {
    /** Landing site */
    TelemetryService["Lnd"] = "LND";
    /** Main app */
    TelemetryService["App"] = "APP";
    /** REST API */
    TelemetryService["Api"] = "API";
    /** FTP ingestion */
    TelemetryService["Ftp"] = "FTP";
    /** Ingest processor */
    TelemetryService["Ing"] = "ING";
    /** Observatory */
    TelemetryService["Obs"] = "OBS";
    /** Billing */
    TelemetryService["Bil"] = "BIL";
})(TelemetryService || (TelemetryService = {}));
